import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  HOME_VIBE_CODE_PUBLISH_BEGIN,
  HOME_VIBE_CODE_PUBLISH_SUCCESS,
  HOME_VIBE_CODE_PUBLISH_ERROR,
  HOME_VIBE_CODE_PUBLISH_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function publishVibeCode(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_VIBE_CODE_PUBLISH_BEGIN,
    });
    const { projectId, latestVersion, envType, subscription } = args;
    const header = builderSurfaceJsonContentHeader(projectId, true);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${latestVersion}/vibe-coding/workspace/publish`,
        { envType, subscription },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_VIBE_CODE_PUBLISH_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          console.log('err', err);
          dispatch({
            type: HOME_VIBE_CODE_PUBLISH_ERROR,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissPublishVibeCodeError() {
  return {
    type: HOME_VIBE_CODE_PUBLISH_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_VIBE_CODE_PUBLISH_BEGIN:
      return {
        ...state,
        updateLatestPublishVersionPending: true,
        updateLatestPublishVersionError: null,
      };

    case HOME_VIBE_CODE_PUBLISH_SUCCESS:
      return {
        ...state,
        updateLatestPublishVersionPending: false,
        updateLatestPublishVersionError: null,
      };

    case HOME_VIBE_CODE_PUBLISH_ERROR:
      return {
        ...state,
        updateLatestPublishVersionPending: false,
        updateLatestPublishVersionError: action.data.error,
      };

    case HOME_VIBE_CODE_PUBLISH_DISMISS_ERROR:
      return {
        ...state,
        updateLatestPublishVersionError: null,
      };

    default:
      return state;
  }
}
